import "./index.css";
import { ChevronLeftIcon, ChevronRightIcon } from "lucide-react";
import { useCallback, useState } from "react";

type IProps = {
  imageUrls: string[];
  index?: number;
};

export const ImageGallery = ({ imageUrls, index = 0 }: IProps) => {
  const [currentIndex, setCurrentIndex] = useState(index);

  const goToPrevious = useCallback(() => {
    setCurrentIndex((prev) => (prev === 0 ? imageUrls.length - 1 : prev - 1));
  }, [imageUrls.length]);

  const goToNext = useCallback(() => {
    setCurrentIndex((prev) => (prev === imageUrls.length - 1 ? 0 : prev + 1));
  }, [imageUrls.length]);

  if (imageUrls.length === 0 || imageUrls.length === 0) {
    return null;
  }

  const showArrows = imageUrls.length > 1;

  return (
    <div className="image-gallery">
      <img
        src={imageUrls[currentIndex]}
        alt={`Preview ${currentIndex + 1}`}
        className="image-gallery__image"
      />
      {showArrows && (
        <>
          <button
            className="image-gallery__nav image-gallery__nav--left"
            onClick={goToPrevious}
          >
            <ChevronLeftIcon size="0.875rem" />
          </button>

          <button
            className="image-gallery__nav image-gallery__nav--right"
            onClick={goToNext}
          >
            <ChevronRightIcon size="0.875rem" />
          </button>
        </>
      )}
    </div>
  );
};
